module.exports = __webpack_public_path__ + "img/HomeCell.fca2823c.svg";